import { useMemo, useState } from 'react';
import { portfolioFilters, portfolioProjects } from '../assets/siteData';
import { ProjectCard } from '../components/ProjectCard';
import { ProjectModal } from '../components/ProjectModal';
import { Section } from '../components/Section';

export function PortfolioPage() {
  const [filter, setFilter] = useState('All');
  const [selectedProject, setSelectedProject] = useState(null);

  const filteredProjects = useMemo(() => {
    if (filter === 'All') {
      return portfolioProjects;
    }

    return portfolioProjects.filter((project) => project.category === filter);
  }, [filter]);

  return (
    <>
      <Section
        eyebrow="Portfolio"
        title="Real founder builds and client projects across websites and web apps"
        description="Filter the work and open any card to view the live project context and platform availability."
      >
        <div className="filter-row">
          {portfolioFilters.map((item) => (
            <button
              key={item}
              type="button"
              className={`filter-chip ${filter === item ? 'is-active' : ''}`}
              onClick={() => setFilter(item)}
            >
              {item}
            </button>
          ))}
        </div>

        <div className="portfolio-grid">
          {filteredProjects.map((project) => (
            <ProjectCard key={project.title} project={project} onSelect={setSelectedProject} />
          ))}
        </div>
      </Section>

      <ProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />
    </>
  );
}
